import { ClipFeedClip } from '../Player/player.types';
import { TeamGame, DnorGame } from '@shd/jslib/models/shd';
export interface ToastData {
  label: string;
  title?: string;
  url?: string;
  background?: string;
  duration?: number;
}

export interface HitScopeToastProps {
  toast: ToastData | null;
  setToast: (toast: ToastData | null) => void;
  handleDownloadClip: (url: string | undefined) => void;
}

export interface HitScopeClip extends ClipFeedClip {
  teamNameMed: string[];
  startTs: number;
  endTs: number;
  playerId?: string;
  textDescription?: string;
}

export const enum TimePeriod {
  ALL_TIME = 'all-time',
  LAST_MONTH = 'last month',
  LAST_7 = 'last 7 days',
}

export const enum Hit {
  HITS = 'hits',
  BATTED_OUTS = 'batted outs',
  ALL_CONTACT = 'all contact',
  BEST_HITS = 'best hits',
}

export const PLAYER_TIME_OPTIONS = [
  TimePeriod.ALL_TIME,
  TimePeriod.LAST_MONTH,
  TimePeriod.LAST_7,
];
export const PLAYER_HIT_OPTIONS = [Hit.HITS, Hit.BATTED_OUTS, Hit.ALL_CONTACT];
export const TEAM_TIME_OPTIONS = [TimePeriod.LAST_7, TimePeriod.LAST_MONTH];
export const TEAM_HIT_OPTIONS = [Hit.HITS, Hit.BEST_HITS];

export const DAY = 24 * 60 * 60;

export interface HitScopeFiltersProps {
  setEndAtTs: (val: number) => void;
  setHitType: (val: Hit) => void;
  loading: boolean;
  track: {
    gameId?: string;
    playerId?: string;
    teamId?: string;
    type: 'player' | 'team' | 'game';
  };
}

export interface ClipQuery {
  time: TimePeriod;
  type: Hit;
}

export interface TeamsHitScopeProps {
  teamIdsString: string;
}

export interface HitScopeProps {
  type: 'player' | 'game' | 'team';
}

export interface HitScopeClipListProps {
  clips: HitScopeClip[];
  selectedClip: HitScopeClip | undefined;
  setManualSelectedClip: (clip: HitScopeClip) => void;
  track: {
    gameId?: string;
    playerId?: string;
    teamId?: string;
    type: HitScopeProps['type'];
  };
  loading: boolean;
}

export interface FetchClipRequest {
  playerId?: string;
  gameId?: string;
  teamIds?: string;
  endAtTs?: number;
  good?: boolean;
  qType?: string;
  us?: string;
  them?: string;
}

export interface HitScopeClipListProps {
  clips: HitScopeClip[];
  selectedClip: HitScopeClip | undefined;
  track: {
    gameId?: string;
    playerId?: string;
    teamId?: string;
    type: 'player' | 'team' | 'game';
  };
}

export interface ScoreByInningsProps {
  gameData: TeamGame &
    DnorGame & { homeRunsByInning?: number[][]; awayRunsByInning?: number[][] };
}
